import clsx from "clsx";
import throttle from "lodash/throttle";
import React, { useEffect, useMemo, useState } from "react";
import { IconButton } from "web/react/components/buttons/icon-button/icon-button";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./back-to-top-button.css";

export function BackToTopButton(): JSX.Element {
    const [visible, setVisible] = useState(false);

    const handleScroll = useMemo(
        () =>
            throttle(() => {
                const onePageHeight = window.innerHeight * 5;
                setVisible(window.scrollY > onePageHeight);
            }, 100),
        []
    );
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            handleScroll.cancel();
        };
    }, [handleScroll]);

    useEffect(() => {
        if (visible) {
            analytics.event(
                "back_to_top",
                "impression",
                "back_to_top",
                false,
                null,
                "back_to_top.impression"
            );
        }
    }, [visible]);

    const scrollToTop = (): void => {
        analytics.event(
            "back_to_top",
            "clicked",
            "back_to_top",
            false,
            null,
            "back_to_top.clicked"
        );
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };

    return (
        <IconButton
            aria-label={gettext("back_to_top")}
            onClick={scrollToTop}
            icon={<SVGIcon name="chevron" rotate={270} />}
            dataTestId={"back-to-top-button"}
            className={clsx(styles.button, visible && styles.visible)}
        />
    );
}
